import { Form, FormField } from "common/Forms"
import { DateInput, SelectInput } from "common/Forms/inputs";
import { Grid, GridCell } from "common/Grid/Grid"
import { ScreenSizes, useScreenSizes } from "common/Grid/useScreenSize";
import { orderingOptionsProvider, paymentOptionsProvider } from "Constant/Constant";
import { useCallback, useState } from "react";

export const AdminFeeAdvanceSearchForm = ({siteIdOptions, userInput, saveUserInput}) => {

  const screenSize = useScreenSizes();
  const [openEndDate, setOpenEndDate] = useState(false);
  const [openStartDate, setOpenStartDate] = useState(false);

  const setUserInput = useCallback((input, deferApply = false) => {
    saveUserInput(input, deferApply);
  }, [saveUserInput]);
  return (
    <Form>
      <Grid columns={screenSize === ScreenSizes.Large ? 4 : screenSize === ScreenSizes.Medium ? 2 : 1}>
        <GridCell>
          <FormField
            id="orderingOptions"
            label="Ordering Options"
            inputFactory={(id, name, oninValidition) =>
              <SelectInput disabled={false}
                id={id} name={name}
                placeholder={"Select ordering options"}
                selectedKey={userInput.orderingOptions}
                optionProvider={() => orderingOptionsProvider}
                keySelector={(x => `${x.value}`)}
                labelSelector={(x => `${x.label}`)}
                onValidation={oninValidition}
                onChange={(_, n, selector) => setUserInput({ ...userInput, orderingOptions: n ? selector(n) : '' })} />
            } />
        </GridCell>
        <GridCell>
          <FormField
            id="siteid"
            label="Site ID"
            inputFactory={(id, name, oninValidition) =>
              <SelectInput disabled={false}
                id={id} name={name}
                placeholder="Select site id"
                selectedKey={userInput.siteid}
                optionProvider={() => siteIdOptions}
                keySelector={(x => `${x.value}`)}
                labelSelector={(x => `${x.label}`)}
                onValidation={oninValidition}
                onChange={(_, n, selector) => setUserInput({ ...userInput, siteid: n ? selector(n) : '' })} />
            } />
        </GridCell>
        <GridCell>
          <FormField
            id="start_date"
            name='Start date'
            label="Start Date"
            inputFactory={(id, name, onValidation) =>
              <DateInput
                id={id}
                name={name}
                disabled={false}
                placeholder="Select start date"
                value={userInput?.startDateFrom}
                onValidation={onValidation}
                open={openStartDate}
                onCalendarClose={() => setOpenStartDate(false)}
                onChange={(_, n) => {
                  const startDate = n ? new Date(n) : "";
                  const endDate = userInput?.endDateFrom ? new Date(userInput.endDateFrom) : null;

                  setOpenStartDate(false);
                  if (endDate && startDate && startDate > endDate) {
                    setUserInput({ ...userInput, startDateFrom: startDate, endDateFrom: "" }, true);
                    setOpenEndDate(true);
                  } else if (n && !userInput?.endDateFrom) {
                    setUserInput({ ...userInput, startDateFrom: startDate }, true);
                    setOpenEndDate(true);
                  } else if (!n) {
                    setUserInput({ ...userInput, startDateFrom: startDate, endDateFrom: "" });
                    setOpenEndDate(false);
                  } else {
                    setUserInput({ ...userInput, startDateFrom: startDate });
                    setOpenEndDate(false);
                  }
                }}/>
              }
          />
        </GridCell>
        <GridCell>
          <FormField
            id="end_date"
            name='End date'
            label={"End Date"}
            inputFactory={(id, name, onValidation) => (
              <DateInput
                id={id}
                name={name}
                disabled={false}
                placeholder="Select end date"
                value={userInput?.endDateFrom || undefined}
                minDate={userInput?.startDateFrom || undefined}
                onValidation={onValidation}
                open={openEndDate}
                onCalendarClose={() => setOpenEndDate(false)}
                onChange={(_, n) => {
                  const endDate = n ? new Date(n) : "";
                  const startDate = userInput?.startDateFrom ? new Date(userInput.startDateFrom) : null;

                  setOpenEndDate(false);
                  const shouldOpenStartDate = n && !userInput?.startDateFrom;
                  if (startDate && endDate && endDate < startDate) {
                    setUserInput({ ...userInput, endDateFrom: endDate, startDateFrom: "" }, shouldOpenStartDate);
                  } else {
                    setUserInput({ ...userInput, endDateFrom: endDate }, shouldOpenStartDate);
                  }

                  setOpenStartDate(!!shouldOpenStartDate);
                }}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            id="paymentMethod"
            label="Payment Method"
            inputFactory={(id, name, oninValidition) =>
              <SelectInput disabled={false}
                id={id} name={name}
                placeholder="Select payment method"
                selectedKey={userInput.payment}
                optionProvider={() => paymentOptionsProvider}
                keySelector={(x => `${x.value}`)}
                labelSelector={(x => `${x.label}`)}
                onValidation={oninValidition}
                onChange={(_, n, selector) => setUserInput({ ...userInput, payment: n ? selector(n) : '' })} />
            } />
        </GridCell>
      </Grid>
    </Form>
  )
}